import { render, staticRenderFns } from "./taskLog.vue?vue&type=template&id=515ef98e&"
import script from "./taskLog.vue?vue&type=script&lang=js&"
export * from "./taskLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports